import { IdIdentifier, Timestamps, UserIdentifier } from '../common';
import { tiktokDefaultMetadata, TiktokMetadata } from './tiktok-types';
import { YouTubeMetadata } from './youtube-types';
import { instagramDefaultMetadata, InstagramMetadata } from './instagram-types';
import { facebookDefaultMetadata, FacebookMetadata } from './facebook-types';

export type SocialAccount = IdIdentifier &
  Timestamps &
  UserIdentifier & {
    provider: SocialProvider;
    accessToken?: string;
    refreshToken?: string;
    expiresAt: Date;
    avatarUrl?: string;
    externalId: string;
    title: string;
    tokenInvalid: boolean;
    invalidEmailSentAt?: Date;
    invalidEmailSentCount?: number;
    metadata: SocialAccountMetadata;
  };

export enum SocialProvider {
  TikTok = 'tik-tok',
  Instagram = 'instagram',
  YouTube = 'youtube',
  Facebook = 'facebook',
}

export type SocialAccountMetadata =
  | TiktokMetadata
  | YouTubeMetadata
  | InstagramMetadata
  | FacebookMetadata
  | Record<string, unknown>;

export const getDefaultSocialAccountMetadata = (provider: SocialProvider) => {
  if (provider === SocialProvider.TikTok) {
    return tiktokDefaultMetadata;
  }

  if (provider === SocialProvider.Instagram) {
    return instagramDefaultMetadata;
  }

  if (provider === SocialProvider.Facebook) {
    return facebookDefaultMetadata;
  }

  return {};
};
